module.exports = __webpack_public_path__ + "d460d12e7bcb453d46f7c87c42a45f93.png";